// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('contacts.companies.new', {
        url: '/new/',
        views: {
            "contactView@contacts": {
                templateUrl: 'main/contacts/companies/company/company.tpl.html',
                controller: 'CompanyController as vm'
            }
        },
        resolve: {
            company: function() {return {};},
            isNewCompany: function() {return true;},
            companyTypes: companyTypesResolver,
            currencies: currenciesResolver,
            users: usersResolver,
            languages: languagesResolver,
            shippingMethods: shippingMethodsResolver,
            deliveryTerms: deliveryTermsResolver,
            paymentTerms: paymentTermsResolver,
            pricingModels: pricingModelResolver,
            priceLists: priceListResolver
        }
    });

    $stateProvider.state('contacts.companies.company', {
        url: '/{companyId}',
        views: {
            "contactView@contacts": {
                templateUrl: 'main/contacts/companies/company/company.tpl.html',
                controller: 'CompanyController as vm'
            }
        },
        resolve: {
            company: companyResolver,
            isNewCompany: function() {return false;},
            companyTypes: companyTypesResolver,
            currencies: currenciesResolver,
            users: usersResolver,
            languages: languagesResolver,
            shippingMethods: shippingMethodsResolver,
            deliveryTerms: deliveryTermsResolver,
            paymentTerms: paymentTermsResolver,
            pricingModels: pricingModelResolver,
            priceLists: priceListResolver
        }
    });

}

// @ngInject
function companyResolver($stateParams, CompaniesApiService) {
    return CompaniesApiService.getCompany($stateParams.companyId);
}

// @ngInject
function companyTypesResolver(CompaniesApiService) {
    return CompaniesApiService.getCompanyTypes();
}

// @ngInject
function currenciesResolver(CompaniesApiService) {
    return CompaniesApiService.getCurrencies();
}

// @ngInject
function usersResolver(CompaniesApiService) {
    return CompaniesApiService.getActiveUsers();
}

// @ngInject
function languagesResolver(CompaniesApiService) {
    return CompaniesApiService.getLanguages();
}
// @ngInject
function shippingMethodsResolver(CompaniesApiService) {
    return CompaniesApiService.getShippingMethods();
}
// @ngInject
function deliveryTermsResolver(CompaniesApiService) {
    return CompaniesApiService.getDeliveryTerms();
}
// @ngInject
function paymentTermsResolver(CompaniesApiService) {
    return CompaniesApiService.getPaymentTerms();
}
// @ngInject
function pricingModelResolver(CompaniesApiService) {
    return CompaniesApiService.getPricingModels();
}

// @ngInject
function priceListResolver(CompaniesApiService) {
    return CompaniesApiService.getPriceListBriefs();
}

// @ngInject
function CompanyController($state, $filter, $translate, company, isNewCompany, companyTypes, CompaniesApiService, loadSpinnerService, $scope, AuthService, currencies, users, languages, shippingMethods, deliveryTerms, paymentTerms, ToasterService, pricingModels, priceLists) {
    var vm = this;

    //Properties
    vm.companyTypes = companyTypes;
    vm.pricingModels = pricingModels.priceModels;
    vm.languages = languages;
    vm.currencies = currencies;
    if (isNewCompany === undefined || !isNewCompany) {
        vm.company = company;
        vm.company.commissionPercent = vm.company.commissionPercent ? vm.company.commissionPercent * 100 : 0;
        vm.priceModelObject = $filter('filter')(vm.pricingModels, {'name':vm.company.priceModel})[0];

        if (vm.company && vm.company.addresses) {
            _.forEach(vm.company.addresses, function (currAddr) {
                currAddr.addressType = _.find(vm.addressTypes, function(at) { return at.id === currAddr.addressTypeId; });
            });
        }

        vm.isEditing = false;
    } else {
        vm.company = {
            id: -1,
            companyType: vm.companyTypes[0],
            language: vm.languages[0],
            purchasingCurrency: vm.currencies[0]
        };
        vm.priceModelObject = vm.pricingModels[0];
        vm.isEditing = true;
    }
    vm.users = users;
    vm.shippingMethods = shippingMethods;
    vm.paymentTerms = paymentTerms;
    vm.deliveryTerms = deliveryTerms;
    vm.isNewCompany = isNewCompany;
    var companyCopy = angular.copy(vm.company);
    vm.canAccess = AuthService.canAccess;
    vm.newAddress = {};
    vm.newContactInfo = {};
    vm.availableAddressTypes = [];
    vm.availableContactInfoTypes = [];
    vm.addressTypes = [];
    vm.contactInfoTypes = [];
    vm.priceLists = priceLists;
    vm.resellerPriorities = [];
    vm.company.selectedPriority = {};

    //Methods
    vm.addNewAddress = addNewAddress;
    vm.removeAddress = removeAddress;
    vm.addNewContactInfo = addNewContactInfo;
    vm.removeContactInfo = removeContactInfo;
    vm.save = save;
    vm.startEdit = startEdit;
    vm.cancelEdit = cancelEdit;
    vm.allInformationIsValid = allInformationIsValid;
    vm.hasCompanyName = hasCompanyName;
    vm.hasDeliveryTerm = hasDeliveryTerm;
    vm.hasPaymentTerm = hasPaymentTerm;
    vm.hasShippingMethod = hasShippingMethod;
    vm.hasResellerPriceList = hasResellerPriceList;

    activate();

    function activate() {
        CompaniesApiService.getAddressTypes().then(function(types) {
            vm.addressTypes = types;

            if (vm.company && vm.company.addresses) {
                for (var index = 0; index < vm.company.addresses.length; index++) {
                    var currAddr = vm.company.addresses[index];
                    currAddr.addressType = _.find(vm.addressTypes, function(at) { return at.id === currAddr.addressTypeId; });
                }
            }

            resetTypes();
        });
        CompaniesApiService.getContactInfoTypes().then(function(types) {
            vm.contactInfoTypes = types;
            resetTypes();
        });

        if (vm.isNewCompany) {
            vm.isEditing = true;
        }

        vm.resellerPriorities = [
            { code: 'A', displayName: 'A - ' + $translate.instant('resellerorder.priorityA') },
            { code: 'B', displayName: 'B - ' + $translate.instant('resellerorder.priorityB') },
            { code: 'C', displayName: 'C - ' + $translate.instant('resellerorder.priorityC') },
            { code: 'D', displayName: 'D - ' + $translate.instant('resellerorder.priorityD') },
            { code: 'S', displayName: 'S - ' + $translate.instant('resellerorder.priorityS') }
        ];

        applyResellerPriority();
    }

    $scope.$watch(function() { return vm.priceModelObject.id; }, function(oldValue, newValue) {
        vm.company.priceModel = vm.priceModelObject.name;
    });

    function hasCompanyName() {
        return vm.company.companyName && vm.company.companyName.trim().length > 0;
    }
    function hasDeliveryTerm() {
        return vm.company.deliveryTerm && vm.company.deliveryTerm.id > 0;
    }
    function hasPaymentTerm() {
        return vm.company.paymentTerm && vm.company.paymentTerm.id > 0;
    }
    function hasShippingMethod() {
        return vm.company.shippingMethod && vm.company.shippingMethod.id > 0;
    }
    function hasResellerPriceList() {
        if (vm.company.companyType && vm.company.companyType.type === 'reseller') {
            return vm.company.resellerPriceList && vm.company.resellerPriceList.id > 0;
        }
        else { return false; }
    }

    function allInformationIsValid() {
        return hasCompanyName() && hasDeliveryTerm() && hasPaymentTerm() && hasShippingMethod();
    }

    function createCompanyObject(company) {
        if (company.addresses) {
            for (var index = 0; index < company.addresses.length; index++) {
                var currAddr = company.addresses[index];
                currAddr.addressTypeId = currAddr.addressType.id;
            }
        }

        return {
            addresses: company.addresses,
            alternativeCompanyId: company.alternativeCompanyId,
            brands: company.brands,
            commissionPercent: company.commissionPercent / 100,
            companyName: company.companyName,
            companySystemType: company.companyType !== null && company.companyType !== undefined ? company.companyType.companySystemType : 0,
            companyTypeId: company.companyType !== null && company.companyType !== undefined ? company.companyType.id : null,
            contactInfos: company.contactInfos,
            deliveryTermsId: company.deliveryTerm !== null && company.deliveryTerm !== undefined ? company.deliveryTerm.id : null,
            languageId: company.language !== null && company.language !== undefined ? company.language.id : null,
            leadTime: company.leadTime,
            organizationNumber: company.organizationNumber,
            paymentTermsId: company.paymentTerm !== null && company.paymentTerm !== undefined ? company.paymentTerm.id : null,
            priceModel: company.priceModel,
            primaryPurchaserId: company.primaryPurchaser !== null && company.primaryPurchaser !== undefined ? company.primaryPurchaser.id : null,
            priority: company.selectedPriority.code,
            purchasingCurrencyId: company.purchasingCurrency !== null && company.purchasingCurrency !== undefined ? company.purchasingCurrency.id : null,
            resellerPriceListId: company.resellerPriceList !== null && company.resellerPriceList !== undefined ? company.resellerPriceList.id : null,
            shippingMethodId: company.shippingMethod !== null && company.shippingMethod !== undefined ? company.shippingMethod.id : null,
            brandConnectIdentifier: company.brandConnectIdentifier
        };
    }

    function saveNewCompany() {
        loadSpinnerService.start('mainSpinner');
        var companyObject = createCompanyObject(vm.company);
        CompaniesApiService.createCompany(companyObject).then(function(response) {
            $state.go('contacts.companies.company', { companyId: response.id });
            vm.isEditing = false;
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateCompany() {
        loadSpinnerService.start('mainSpinner');

        var companyObject = createCompanyObject(vm.company);

        CompaniesApiService.updateCompany(vm.company.id, companyObject).then(function(response) {
            vm.company = response;
            vm.company.commissionPercent = vm.company.commissionPercent ? vm.company.commissionPercent * 100 : 0;

            if (vm.company && vm.company.addresses) {
                for (var index = 0; index < vm.company.addresses.length; index++) {
                    var currAddr = vm.company.addresses[index];
                    currAddr.addressType = _.find(vm.addressTypes, function(at) { return at.id === currAddr.addressTypeId; });
                }
            }

            companyCopy = angular.copy(response);

            applyResellerPriority();

            vm.isEditing = false;
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

     function addNewAddress() {
        vm.company.addresses = vm.company.addresses || [];
        vm.company.addresses.push(_.clone(vm.newAddress));
        resetTypes();
    }

    function addNewContactInfo() {
        vm.company.contactInfos = vm.company.contactInfos || [];
        vm.company.contactInfos.push(_.clone(vm.newContactInfo));
        resetTypes();
    }

    function removeAddress(address) {
        vm.company.addresses.splice(_.findIndex(vm.company.addresses,{addressType:{typeName:address.addressType.typeName}}),1);
        resetTypes();
    }

    function removeContactInfo(contactInfo) {
        vm.company.contactInfos.splice(_.findIndex(vm.company.contactInfos,{contactInfoType:{typeName:contactInfo.contactInfoType.typeName}}),1);
        resetTypes();
    }

    function getAvailableAddressTypes() {
        return _.filter(vm.addressTypes, function(obj) {
            if (!vm.company.addresses) {
                return true;
            } else {
                return !_.find(vm.company.addresses, { addressType: { id: obj.id }});
            }
        });
    }

    function getAvailableContactInfoTypes() {
        return _.filter(vm.contactInfoTypes, function(obj) { return !_.find(vm.company.contactInfos, {contactInfoType: { id: obj.id }}); });
    }

    function resetTypes() {
        vm.newAddress = {};
        vm.newContactInfo = {};
        vm.availableAddressTypes = getAvailableAddressTypes();
        vm.availableContactInfoTypes = getAvailableContactInfoTypes();
    }

    function save() {
        if (vm.isNewCompany) {
            saveNewCompany();
        } else {
            updateCompany();
        }
    }

    function startEdit() {
        companyCopy = angular.copy(vm.company);
        resetTypes();
        vm.isEditing = true;
    }

    function cancelEdit() {
        vm.company = angular.copy(companyCopy);
        vm.isEditing = false;
    }

    function applyResellerPriority() 
    {
        if (vm.company.priority) {
            vm.company.selectedPriority = _.find(vm.resellerPriorities, function(o) {
                return o.code.toLowerCase() === vm.company.priority.toLowerCase();
            });
        } else {
            vm.company.selectedPriority = vm.resellerPriorities[4];
        }
    }
}

angular.module('companies.company', [])
    .config(stateConfig)
    .controller('CompanyController', CompanyController);
